import InfoCard from "../card/InfoCard";

export default function FoodGuideCard({ food }) {
  const { name, description, images } = food;
  const image = images?.data?.[0]?.attributes;
  const imageUrl = image?.url;
  const imageAlt = image?.alt;

  return (
    <InfoCard
      title={name}
      text={description}
      imageUrl={imageUrl}
      imageAlt={imageAlt}
    />
  );
}
